import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'joinWithAnd',
})
export class JoinWithAndPipe implements PipeTransform {
  public transform(value: any[]): string {
    if (!Array.isArray(value)) {
      return value;
    }

    if (value.length === 0) {
      return '';
    }

    return joinWithAnd(value);
  }
}

export function joinWithAnd(arr: any[]) {
  if (arr.length === 1) {
    return arr[0];
  }
  const firsts = arr.slice(0, arr.length - 1);
  const last = arr[arr.length - 1];
  return `${firsts.join(', ')} and ${last}`;
}
